import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import EntranceGuardDrawer from './modules/EntranceGuardDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList } from '@/api/api';
import EntranceGuardModal from "./modules/EntranceGuardModal";
import { deleteAction, getAction } from '@/api/manage';
export default {
  name: 'EntranceGuardList',
  mixins: [JeecgListMixin],
  components: {
    EntranceGuardModal: EntranceGuardModal // EntranceGuardDrawer

  },
  data: function data() {
    return {
      pagePath: '/sys/entrance/guard',
      pageTitle: '用户门禁管理',
      userTree: [],
      //人员信息
      url: {
        issuance: '/comm/api/issueRpc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '用户',
        align: 'center'
      }, {
        dataIndex: 'createTime',
        colName: 'create_time',
        title: '下发时间',
        align: 'center'
      }, {
        dataIndex: 'cardNumber',
        colName: 'card_number',
        title: '卡号',
        align: 'center'
      }, {
        dataIndex: 'falsePassword',
        colName: 'falsePassword',
        title: '密码',
        align: 'center'
      }, // {
      //   title: '下发状态',
      //   align: 'center',
      //   dataIndex: 'status',
      //   customRender: function(text) {
      //     if (text == 1) {
      //       return '已下发'
      //     } else if (text == 2) {
      //       return '未下发'
      //     } else {
      //       return text
      //     }
      //   }
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    // 加载人员信息
    this.loadTreeList();
  },
  computed: {},
  methods: {
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleAdd: function handleAdd(params) {
      this.$refs.modalForm.add(params);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    InstructionIssuance: function InstructionIssuance(value1, value2) {
      var _this2 = this;

      var that = this;
      var list = {
        cardNumber: value1.cardNumber,
        password: value1.password,
        instructionsType: value2
      };
      var method = 'post';
      httpAction(this.url.issuance, list, method).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });

          if (value2 == '-Delete') {
            _this2.handleDelete(value1.id);
          }
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    batchDel: function batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            deleteAction(that.url && that.url.deleteBatch ? that.url.deleteBatch : that.pagePath + '/deleteBatch', {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var that = this;
      deleteAction(that.url && that.url.delete ? that.url.delete : this.pagePath, {
        id: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          }); //this.queryParam = {}

          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    initTableData: function initTableData(arg) {
      var _this3 = this;

      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      this.loading = true;

      if (this.$refs.page) {
        this.$refs.page.disabled = true;
      }

      getAction(this.url && this.url.list ? this.url.list : this.pagePath, params).then(function (res) {
        if (res.success) {
          _this3.dataSource = res.result.records;

          _this3.dataSource.forEach(function (e) {
            if (e.password != null) {
              e.falsePassword = '********';
            }
          });

          _this3.ipagination.total = res.result.total;
          _this3.loadNums++;
        } else {
          _this3.$message.warning('系统异常=>' + res.message);
        }
      }).finally(function () {
        _this3.loading = false;

        if (_this3.$refs.page) {
          _this3.$refs.page.disabled = false;
        }
      });
    }
  }
};